<template>
  <div id="app">
    <van-action-sheet
      v-model="show"
      :actions="actions"
      cancel-text="取消"
      @cancel="onCancel"
      @select="onSelect"
    />
    <van-nav-bar
      @click-left="onClickLeft"
      @click-right="onClickRight"
    >
      <template #left>
        <van-icon name="arrow-left" size="18" v-if="showback" />
      </template>
      <template #title>
        <a href="//m.yqda.net" class="logo">
          <img alt="<%= htmlWebpackPlugin.options.title %>" src="../assets/logo.png" />
        </a>
      </template>
      <template #right>
        <van-icon name="ellipsis" size="18" />
      </template>
    </van-nav-bar>
    <router-view/>
  </div>
</template>

<script>
import {
  mapGetters
} from 'vuex'
import { NavBar, ActionSheet} from 'vant'
export default {
  components: {
    [NavBar.name]: NavBar,
    [ActionSheet.name]: ActionSheet
  },
  data() {
    return {
      show: false
    }
  },
  computed: {
    ...mapGetters({
      loginState: 'user/loginState',
      userinfo: 'user/userinfo'
    }),
    actions () {
      let menu = []
      if (this.loginState === true) {
        menu = [
          { name: '用户中心' },
          { name: '退出登录' }
        ]
      } else {
        menu = [
          { name: '登录账号' },
          { name: '注册账号' },
          { name: '帮助' }
        ]
      }
      return menu
    },
    showback () {
      return history.length > 0
    }
  },
  methods: {
    onClickLeft() {
      this.$router.back()
    },
    onClickRight() {
      this.show = true
    },
    onCancel() {
      this.show = false
    },
    onSelect(item) {
      this.show = false
      switch (item.name) {
        case '登录账号':
          this.$router.push({ name: 'Login' })
          break;
        case '注册账号':
          this.$router.push({ name: 'Register' })
          break;
        case '用户中心':
          this.$router.push({ name: 'UserCenter' })
          break;
        case '退出登录':
          this.$store.dispatch('user/Logout')
            .then(() => {
              this.$router.push({ name: 'Login' })
            })
            .catch((error) => {
              this.$notify(error)
            })
          break;
        case '帮助':
          this.$router.push({ name: 'ServiceRule' })
          break;
        default:
        
      }
    }
  }
}
</script>

<style lang="less">
h2 { text-align: center; }
.textcenter { text-align: center;}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #ffffff;
  font-size: 14px;
  height: 100%;
}
.main-container {
  margin: 10px 20px;
}
.van-nav-bar {
  border-top: 2px solid #3eb249;
  &__title a{
    display: inline-block;
    line-height: 0;
    vertical-align: middle;
  }
  .van-icon {
    color: #42b983;
  }
}
</style>
